import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _111cc7ac = () => interopDefault(import('../pages/the-project/index.vue' /* webpackChunkName: "pages/the-project/index" */))
const _f95f20ca = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _9623bb1e = () => interopDefault(import('../pages/archive/index.vue' /* webpackChunkName: "pages/archive/index" */))
const _a97b4904 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5463063d = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _7db85185 = () => interopDefault(import('../pages/career/index.vue' /* webpackChunkName: "pages/career/index" */))
const _68c7edac = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _2250974f = () => interopDefault(import('../pages/public-information/index.vue' /* webpackChunkName: "pages/public-information/index" */))
const _6412cf88 = () => interopDefault(import('../pages/visitor-information/index.vue' /* webpackChunkName: "pages/visitor-information/index" */))
const _2fb3c69a = () => interopDefault(import('../pages/complaint-report.vue' /* webpackChunkName: "pages/complaint-report" */))
const _8e5e446c = () => interopDefault(import('../pages/customer-service.vue' /* webpackChunkName: "pages/customer-service" */))
const _34a431ca = () => interopDefault(import('../pages/magazine/index.vue' /* webpackChunkName: "pages/magazine/index" */))
const _1ac2859e = () => interopDefault(import('../pages/mental-liget-event-subscription-confirmation.vue' /* webpackChunkName: "pages/mental-liget-event-subscription-confirmation" */))
const _14296db2 = () => interopDefault(import('../pages/press/index.vue' /* webpackChunkName: "pages/press/index" */))
const _b08fdd56 = () => interopDefault(import('../pages/newsletter-subscription-confirmation.vue' /* webpackChunkName: "pages/newsletter-subscription-confirmation" */))
const _19c823e7 = () => interopDefault(import('../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _bcb28ff0 = () => interopDefault(import('../pages/map.vue' /* webpackChunkName: "pages/map" */))
const _05cd0572 = () => interopDefault(import('../pages/business-partners/index.vue' /* webpackChunkName: "pages/business-partners/index" */))
const _03a40ec2 = () => interopDefault(import('../pages/programs-in-varosliget/index.vue' /* webpackChunkName: "pages/programs-in-varosliget/index" */))
const _41c26148 = () => interopDefault(import('../pages/the-project/our-first-10-years.vue' /* webpackChunkName: "pages/the-project/our-first-10-years" */))
const _70cb09b5 = () => interopDefault(import('../pages/press/media-library/index.vue' /* webpackChunkName: "pages/press/media-library/index" */))
const _043e620e = () => interopDefault(import('../pages/the-project/swiper.vue' /* webpackChunkName: "pages/the-project/swiper" */))
const _15549c50 = () => interopDefault(import('../pages/top-locations/balloon-fly.vue' /* webpackChunkName: "pages/top-locations/balloon-fly" */))
const _29f78a72 = () => interopDefault(import('../pages/top-locations/bird-friendly-learning-trail.vue' /* webpackChunkName: "pages/top-locations/bird-friendly-learning-trail" */))
const _23d628fb = () => interopDefault(import('../pages/top-locations/house-of-hungarian-music.vue' /* webpackChunkName: "pages/top-locations/house-of-hungarian-music" */))
const _74c81964 = () => interopDefault(import('../pages/top-locations/house-of-the-hungarian-millennium.vue' /* webpackChunkName: "pages/top-locations/house-of-the-hungarian-millennium" */))
const _a0a9ee42 = () => interopDefault(import('../pages/top-locations/mocsenyi-mihaly-botanical-garden.vue' /* webpackChunkName: "pages/top-locations/mocsenyi-mihaly-botanical-garden" */))
const _65fb3726 = () => interopDefault(import('../pages/top-locations/museum-of-ethnography.vue' /* webpackChunkName: "pages/top-locations/museum-of-ethnography" */))
const _82beccea = () => interopDefault(import('../pages/top-locations/museum-of-fine-arts.vue' /* webpackChunkName: "pages/top-locations/museum-of-fine-arts" */))
const _4822a182 = () => interopDefault(import('../pages/top-locations/city-park-visitor-center.vue' /* webpackChunkName: "pages/top-locations/city-park-visitor-center" */))
const _01034382 = () => interopDefault(import('../pages/top-locations/kresz-park.vue' /* webpackChunkName: "pages/top-locations/kresz-park" */))
const _297a74ff = () => interopDefault(import('../pages/top-locations/playground-of-varosliget.vue' /* webpackChunkName: "pages/top-locations/playground-of-varosliget" */))
const _025a8747 = () => interopDefault(import('../pages/top-locations/varosliget-promenade.vue' /* webpackChunkName: "pages/top-locations/varosliget-promenade" */))
const _beeb8d24 = () => interopDefault(import('../pages/magazine/preview/_article_preview.vue' /* webpackChunkName: "pages/magazine/preview/_article_preview" */))
const _614bd3fe = () => interopDefault(import('../pages/press/media-library/_gallerycategory/index.vue' /* webpackChunkName: "pages/press/media-library/_gallerycategory/index" */))
const _bea90410 = () => interopDefault(import('../pages/programs-in-varosliget/preview/_program_preview.vue' /* webpackChunkName: "pages/programs-in-varosliget/preview/_program_preview" */))
const _0e6e6034 = () => interopDefault(import('../pages/press/media-library/_gallerycategory/_gallery.vue' /* webpackChunkName: "pages/press/media-library/_gallerycategory/_gallery" */))
const _06e2a168 = () => interopDefault(import('../pages/archive/_article.vue' /* webpackChunkName: "pages/archive/_article" */))
const _197b8172 = () => interopDefault(import('../pages/business-partners/_partnerInfo.vue' /* webpackChunkName: "pages/business-partners/_partnerInfo" */))
const _4663ba8a = () => interopDefault(import('../pages/career/_position.vue' /* webpackChunkName: "pages/career/_position" */))
const _7b0b38f4 = () => interopDefault(import('../pages/public-information/_data.vue' /* webpackChunkName: "pages/public-information/_data" */))
const _0329a47e = () => interopDefault(import('../pages/magazine/_article.vue' /* webpackChunkName: "pages/magazine/_article" */))
const _17ef6d18 = () => interopDefault(import('../pages/press/_release.vue' /* webpackChunkName: "pages/press/_release" */))
const _8259bb52 = () => interopDefault(import('../pages/program-series/_programSeries.vue' /* webpackChunkName: "pages/program-series/_programSeries" */))
const _2e16cf08 = () => interopDefault(import('../pages/programs-in-varosliget/_program.vue' /* webpackChunkName: "pages/programs-in-varosliget/_program" */))
const _13733a20 = () => interopDefault(import('../pages/the-project/_project.vue' /* webpackChunkName: "pages/the-project/_project" */))
const _2e33c8e7 = () => interopDefault(import('../pages/visitor-information/_visitorInformation.vue' /* webpackChunkName: "pages/visitor-information/_visitorInformation" */))
const _ace88b94 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-projekt",
    component: _111cc7ac,
    name: "the-project___hu"
  }, {
    path: "/adatvedelem",
    component: _f95f20ca,
    name: "privacy-policy___hu"
  }, {
    path: "/archivum",
    component: _9623bb1e,
    name: "archive___hu"
  }, {
    path: "/en",
    component: _a97b4904,
    name: "index___en"
  }, {
    path: "/hirlevel-feliratkozas",
    component: _5463063d,
    name: "newsletter___hu"
  }, {
    path: "/karrier",
    component: _7db85185,
    name: "career___hu"
  }, {
    path: "/kereses",
    component: _68c7edac,
    name: "search___hu"
  }, {
    path: "/kozerdeku-adatok",
    component: _2250974f,
    name: "public-information___hu"
  }, {
    path: "/latogatas",
    component: _6412cf88,
    name: "visitor-information___hu"
  }, {
    path: "/liget-budapest-panaszkezeles",
    component: _2fb3c69a,
    name: "complaint-report___hu"
  }, {
    path: "/liget-budapest-ugyfelszolgalat",
    component: _8e5e446c,
    name: "customer-service___hu"
  }, {
    path: "/magazin",
    component: _34a431ca,
    name: "magazine___hu"
  }, {
    path: "/mental-liget-sikeres-feliratkozas",
    component: _1ac2859e,
    name: "mental-liget-event-subscription-confirmation___hu"
  }, {
    path: "/sajto",
    component: _14296db2,
    name: "press___hu"
  }, {
    path: "/sikeres-feliratkozas",
    component: _b08fdd56,
    name: "newsletter-subscription-confirmation___hu"
  }, {
    path: "/szakmai-anyagok",
    component: _19c823e7,
    name: "documents___hu"
  }, {
    path: "/terkep",
    component: _bcb28ff0,
    name: "map___hu"
  }, {
    path: "/uzleti-partnereinknek",
    component: _05cd0572,
    name: "business-partners___hu"
  }, {
    path: "/varosligeti-programok",
    component: _03a40ec2,
    name: "programs-in-varosliget___hu"
  }, {
    path: "/en/archive",
    component: _9623bb1e,
    name: "archive___en"
  }, {
    path: "/en/business-partners",
    component: _05cd0572,
    name: "business-partners___en"
  }, {
    path: "/en/career",
    component: _7db85185,
    name: "career___en"
  }, {
    path: "/en/hirlevel-feliratkozas",
    component: _5463063d,
    name: "newsletter___en"
  }, {
    path: "/en/kozerdeku-adatok",
    component: _2250974f,
    name: "public-information___en"
  }, {
    path: "/en/liget-budapest-complaint-report",
    component: _2fb3c69a,
    name: "complaint-report___en"
  }, {
    path: "/en/liget-budapest-customer-service",
    component: _8e5e446c,
    name: "customer-service___en"
  }, {
    path: "/en/magazine",
    component: _34a431ca,
    name: "magazine___en"
  }, {
    path: "/en/map",
    component: _bcb28ff0,
    name: "map___en"
  }, {
    path: "/en/mental-liget-subscription-successful",
    component: _1ac2859e,
    name: "mental-liget-event-subscription-confirmation___en"
  }, {
    path: "/en/press",
    component: _14296db2,
    name: "press___en"
  }, {
    path: "/en/privacy-policy",
    component: _f95f20ca,
    name: "privacy-policy___en"
  }, {
    path: "/en/programs-in-varosliget",
    component: _03a40ec2,
    name: "programs-in-varosliget___en"
  }, {
    path: "/en/search",
    component: _68c7edac,
    name: "search___en"
  }, {
    path: "/en/subscription-successful",
    component: _b08fdd56,
    name: "newsletter-subscription-confirmation___en"
  }, {
    path: "/en/szakmai-anyagok",
    component: _19c823e7,
    name: "documents___en"
  }, {
    path: "/en/the-project",
    component: _111cc7ac,
    name: "the-project___en"
  }, {
    path: "/en/visitor-information",
    component: _6412cf88,
    name: "visitor-information___en"
  }, {
    path: "/projekt/a-liget-projekt-elso-10-eve",
    component: _41c26148,
    name: "the-project-our-first-10-years___hu"
  }, {
    path: "/sajto/mediatar",
    component: _70cb09b5,
    name: "press-media-library___hu"
  }, {
    path: "/the-project/swiper",
    component: _043e620e,
    name: "the-project-swiper___hu"
  }, {
    path: "/top-helyek/ballon-kilato",
    component: _15549c50,
    name: "top-locations-balloon-fly___hu"
  }, {
    path: "/top-helyek/madarbarat-tanosveny",
    component: _29f78a72,
    name: "top-locations-bird-friendly-learning-trail___hu"
  }, {
    path: "/top-helyek/magyar-zene-haza",
    component: _23d628fb,
    name: "top-locations-house-of-hungarian-music___hu"
  }, {
    path: "/top-helyek/millennium-haza-neo-kortars-muveszeti-ter",
    component: _74c81964,
    name: "top-locations-house-of-the-hungarian-millennium___hu"
  }, {
    path: "/top-helyek/mocsenyi-mihaly-botanikus-kert",
    component: _a0a9ee42,
    name: "top-locations-mocsenyi-mihaly-botanical-garden___hu"
  }, {
    path: "/top-helyek/neprajzi-muzeum",
    component: _65fb3726,
    name: "top-locations-museum-of-ethnography___hu"
  }, {
    path: "/top-helyek/szepmuveszeti-muzeum",
    component: _82beccea,
    name: "top-locations-museum-of-fine-arts___hu"
  }, {
    path: "/top-helyek/varosliget-latogatokozpont",
    component: _4822a182,
    name: "top-locations-city-park-visitor-center___hu"
  }, {
    path: "/top-helyek/varosligeti-kresz-park",
    component: _01034382,
    name: "top-locations-kresz-park___hu"
  }, {
    path: "/top-helyek/varosligeti-nagyjatszoter",
    component: _297a74ff,
    name: "top-locations-playground-of-varosliget___hu"
  }, {
    path: "/top-helyek/varosligeti-promenad",
    component: _025a8747,
    name: "top-locations-varosliget-promenade___hu"
  }, {
    path: "/en/press/media",
    component: _70cb09b5,
    name: "press-media-library___en"
  }, {
    path: "/en/the-project/our-first-10-years",
    component: _41c26148,
    name: "the-project-our-first-10-years___en"
  }, {
    path: "/en/the-project/swiper",
    component: _043e620e,
    name: "the-project-swiper___en"
  }, {
    path: "/en/top-locations/balloon-fly",
    component: _15549c50,
    name: "top-locations-balloon-fly___en"
  }, {
    path: "/en/top-locations/bird-friendly-learning-trail",
    component: _29f78a72,
    name: "top-locations-bird-friendly-learning-trail___en"
  }, {
    path: "/en/top-locations/city-park-visitor-center",
    component: _4822a182,
    name: "top-locations-city-park-visitor-center___en"
  }, {
    path: "/en/top-locations/house-of-hungarian-music",
    component: _23d628fb,
    name: "top-locations-house-of-hungarian-music___en"
  }, {
    path: "/en/top-locations/house-of-the-hungarian-millennium",
    component: _74c81964,
    name: "top-locations-house-of-the-hungarian-millennium___en"
  }, {
    path: "/en/top-locations/kresz-park",
    component: _01034382,
    name: "top-locations-kresz-park___en"
  }, {
    path: "/en/top-locations/mocsenyi-mihaly-botanical-garden",
    component: _a0a9ee42,
    name: "top-locations-mocsenyi-mihaly-botanical-garden___en"
  }, {
    path: "/en/top-locations/museum-of-ethnography",
    component: _65fb3726,
    name: "top-locations-museum-of-ethnography___en"
  }, {
    path: "/en/top-locations/museum-of-fine-arts",
    component: _82beccea,
    name: "top-locations-museum-of-fine-arts___en"
  }, {
    path: "/en/top-locations/playground-of-varosliget",
    component: _297a74ff,
    name: "top-locations-playground-of-varosliget___en"
  }, {
    path: "/en/top-locations/varosliget-promenade",
    component: _025a8747,
    name: "top-locations-varosliget-promenade___en"
  }, {
    path: "/en/magazine/preview/:article_preview",
    component: _beeb8d24,
    name: "magazine-preview-article_preview___en"
  }, {
    path: "/en/press/media/:gallerycategory",
    component: _614bd3fe,
    name: "press-media-library-gallerycategory___en"
  }, {
    path: "/en/programs-in-varosliget/preview/:program_preview",
    component: _bea90410,
    name: "programs-in-varosliget-preview-program_preview___en"
  }, {
    path: "/en/press/media/:gallerycategory/:gallery",
    component: _0e6e6034,
    name: "press-media-library-gallerycategory-gallery___en"
  }, {
    path: "/en/archive/:article",
    component: _06e2a168,
    name: "archive-article___en"
  }, {
    path: "/en/business-partners/:partnerInfo",
    component: _197b8172,
    name: "business-partners-partnerInfo___en"
  }, {
    path: "/en/career/:position",
    component: _4663ba8a,
    name: "career-position___en"
  }, {
    path: "/en/kozerdeku-adatok/:data",
    component: _7b0b38f4,
    name: "public-information-data___en"
  }, {
    path: "/en/magazine/:article",
    component: _0329a47e,
    name: "magazine-article___en"
  }, {
    path: "/en/press/:release",
    component: _17ef6d18,
    name: "press-release___en"
  }, {
    path: "/en/program-series/:programSeries",
    component: _8259bb52,
    name: "program-series-programSeries___en"
  }, {
    path: "/en/programs-in-varosliget/:program",
    component: _2e16cf08,
    name: "programs-in-varosliget-program___en"
  }, {
    path: "/en/the-project/:project",
    component: _13733a20,
    name: "the-project-project___en"
  }, {
    path: "/en/visitor-information/:visitorInformation",
    component: _2e33c8e7,
    name: "visitor-information-visitorInformation___en"
  }, {
    path: "/magazin/preview/:article_preview",
    component: _beeb8d24,
    name: "magazine-preview-article_preview___hu"
  }, {
    path: "/sajto/mediatar/:gallerycategory",
    component: _614bd3fe,
    name: "press-media-library-gallerycategory___hu"
  }, {
    path: "/varosligeti-programok/preview/:program_preview",
    component: _bea90410,
    name: "programs-in-varosliget-preview-program_preview___hu"
  }, {
    path: "/sajto/mediatar/:gallerycategory/:gallery",
    component: _0e6e6034,
    name: "press-media-library-gallerycategory-gallery___hu"
  }, {
    path: "/archivum/:article",
    component: _06e2a168,
    name: "archive-article___hu"
  }, {
    path: "/en/:slug",
    component: _ace88b94,
    name: "slug___en"
  }, {
    path: "/karrier/:position",
    component: _4663ba8a,
    name: "career-position___hu"
  }, {
    path: "/kozerdeku-adatok/:data",
    component: _7b0b38f4,
    name: "public-information-data___hu"
  }, {
    path: "/latogatas/:visitorInformation",
    component: _2e33c8e7,
    name: "visitor-information-visitorInformation___hu"
  }, {
    path: "/magazin/:article",
    component: _0329a47e,
    name: "magazine-article___hu"
  }, {
    path: "/programsorozatok/:programSeries",
    component: _8259bb52,
    name: "program-series-programSeries___hu"
  }, {
    path: "/projekt/:project",
    component: _13733a20,
    name: "the-project-project___hu"
  }, {
    path: "/sajto/:release",
    component: _17ef6d18,
    name: "press-release___hu"
  }, {
    path: "/uzleti-partnereinknek/:partnerInfo",
    component: _197b8172,
    name: "business-partners-partnerInfo___hu"
  }, {
    path: "/varosligeti-programok/:program",
    component: _2e16cf08,
    name: "programs-in-varosliget-program___hu"
  }, {
    path: "/",
    component: _a97b4904,
    name: "index___hu"
  }, {
    path: "/:slug",
    component: _ace88b94,
    name: "slug___hu"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
